// Convention AnyHomes pour une location :
//  - `propertyMonthlyCharges`     = loyer (hors charges)
//  - `propertyChargesMonthly`     = charges mensuelles (provision)
// Le prix affiché aux visiteurs est le loyer CHARGES COMPRISES (comme les
// annonces d'origine : leboncoin, agences…), soit la somme des deux.
// Repli sur `price` pour les annonces importées plus anciennes.

export const monthlyChargesOf = (property) =>
  Number(property?.propertyChargesMonthly) || 0;

export const monthlyRentTotal = (property) => {
  const rent = Number(property?.propertyMonthlyCharges) || 0;
  const charges = monthlyChargesOf(property);
  const total = rent + charges;
  if (total > 0) return total;
  return Number(property?.price) || 0;
};

export default monthlyRentTotal;
